import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { colors } from '@fs/zion-ui'

const highlightedTextCss = css`
  background-color: ${colors.yellow05};
`

export default function TextHighlighter({ children, textToHighlight = [] }) {
  if (!children) {
    return null
  }

  const indexesToHighlight = new Set()

  ;[].concat(textToHighlight).forEach((value) => {
    const index = children.toLowerCase().indexOf(value.toLowerCase())

    if (index > -1) {
      ;[...Array(value.length).keys()].forEach((i) => indexesToHighlight.add(index + i))
    }
  })

  if (indexesToHighlight.size) {
    return children.split('').map((character, i) =>
      indexesToHighlight.has(i) ? (
        <span css={highlightedTextCss} key={`character_${character + i}`}>
          {character}
        </span>
      ) : (
        character
      )
    )
  }

  return children
}

TextHighlighter.propTypes = {
  children: PropTypes.node,
  textToHighlight: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
}
